import React, { useEffect, useState } from "react";
import DetailsSlider from "../Slider/DetailsSlider";
import { BiMinus, BiPlus } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/features/cart/cartSlice";
import StarRatings from "react-star-ratings";
import ReviewCard from "./ReviewCard";
import { MdRateReview } from "react-icons/md";
import { toast } from "react-toastify";
import {
  createProductReview,
  getProductDetails,
} from "../../redux/features/product/productSlice";
import Spinner from "../Spinner";
const rev = 2;

const ProuductDetails = () => {
  const { id } = useParams();
  const [itemQuantity, setItemQuantity] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const [createRate, setCreateRate] = useState(0);

  const { product, isLoading, isSuccess } = useSelector(
    (state) => state.products
  );

  // products.find((product) => product._id === id) ||
  // featureProducts.find((product) => product._id === id);

  useEffect(() => {
    const productId = id;
    dispatch(getProductDetails(productId));
  }, [id, isSuccess]);

  const increamentHandler = () => {
    setItemQuantity(itemQuantity + 1);
  };

  const decreamentHandler = () => {
    if (itemQuantity > 1) {
      setItemQuantity(itemQuantity - 1);
    }
  };
  const addTocartHanlder = () => {
    dispatch(
      addToCart({
        name: product.name,
        id: product.id,
        price: product.price,
        image: product.images[0].url,
        description: product.description,
        quantity: itemQuantity,
      })
    );
  };

  const buyNowHanlder = () => {
    dispatch(
      addToCart({
        name: product.name,
        id: product.id,
        price: product.price,
        image: product.images[0].url,
        description: product.description,
        quantity: itemQuantity,
      })
    );

    navigate("/cart");
  };

  const commentSubmitHandler = (e) => {
    e.preventDefault();
    if (comment === "" || createRate === 0) {
      toast.error("Please Write comment and Set Rate");
    }

    const reviewData = {
      rating: createRate,
      comment: comment,
      productId: id,
      // date: new Date().toISOString(),
    };
    dispatch(createProductReview(reviewData));
    // dispatch(getAllProducts());
    setComment("");
    setCreateRate(0);
    dispatch(getProductDetails(id));
  };
  return (
    <>
      {isLoading ? (
        <div className=" min-h-screen">
          <Spinner />
        </div>
      ) : (
        <>
          {product === null ? (
            <div className="">
              <h1>product not found</h1>
            </div>
          ) : (
            <div className="flex flex-col bg-white">
              <div className="px-[10px] md:px-[15px] lg:px-[8vw] pt-10 mb-10">
                <div className="grid grid-cols-1 pb-20 md:grid-cols-12">
                  <div className=" md:col-span-5 bg-whites mb-10 rounded-b-xl">
                    <div className="w-[100%] flex justify-center">
                      <DetailsSlider images={product?.images} h={350} />
                    </div>
                  </div>

                  <div className=" md:col-span-7">
                    <div className="px-3 md:ml-10">
                      <p className="text-lg font-bold my-2">{product?.name}</p>
                      <div className="flex flex-row justify-between  my-2">
                        <div className=" flex  items-center mb-1 ">
                          <StarRatings
                            rating={product.ratings}
                            starRatedColor="#FFBF00"
                            // changeRating={this.changeRating}
                            numberOfStars={5}
                            name="rating"
                            starDimension="20px"
                            starSpacing="3px"
                          />
                          <span className=" ml-2">
                            ({product.numOfReviews})
                          </span>
                        </div>
                        {product?.stock > 0 ? (
                          <p className="text-sm text-green-500">In Stock</p>
                        ) : (
                          <p className="text-sm text-red-500">Stock out</p>
                        )}
                      </div>
                      <h1 className="text-2xl mb-3 ">Key Feature</h1>
                      <ul>
                        {product.keyFeatures?.map((feature, index) => (
                          <li
                            className=" font-semibold text-slate-800"
                            key={index}
                          >
                            ✅{feature}
                          </li>
                        ))}
                      </ul>

                      <div className=" flex items-center justify-start mt-5 ">
                        <button onClick={increamentHandler}>
                          <BiPlus className="text-lg text-green-500" />
                        </button>
                        <span className="border px-2 mx-1">{itemQuantity}</span>
                        <button onClick={decreamentHandler}>
                          <BiMinus className="text-lg text-red-500" />
                        </button>
                      </div>
                      <h1 className="text-xl md:text-2xl font-bold my-5 text-[#FF7A00]">
                        ৳{product.price * itemQuantity}
                        <span className="text-slate-500 line-through ml-3">
                          ৳{product.price + 8000}.25
                        </span>
                      </h1>
                      <div>
                        <button
                          onClick={addTocartHanlder}
                          className="mr-2 bg-[#F37613] hover:bg-[#cb6716] transition-all duration-500 my-2 text-center self-center px-5 py-1 text-white w-fit bottom-0"
                        >
                          Add to Cart
                        </button>
                        <button
                          onClick={buyNowHanlder}
                          className="ml-2 bg-green-600 hover:bg-green-700 transition-all duration-500 my-2 text-center self-center px-5 py-1 text-white w-fit bottom-0"
                        >
                          Buy Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-slate-50">
                {/* <div className="bg-slate-100"> */}
                {product?.spec && (
                  <div className="bg-white shadow rounded my-10 p-5 mx-[10px] md:mx-[15px] lg:mx-[8vw] ">
                    <table className="w-full border-collapse">
                      <thead>
                        <tr>
                          <th className="border-b border-gray-300 px-4 py-2 text-left">
                            Specification
                          </th>
                          <th className="border-b border-gray-300 px-4 py-2 text-left">
                            Details
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {product?.spec?.map((s) => (
                          <tr>
                            <td className="border-b border-gray-300 px-4 py-2">
                              {s.name}
                            </td>
                            <td className="border-b border-gray-300 px-4 py-2">
                              {s.value}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="flex flex-col rounded-sm bg-white my-10 shadow p-5 mx-[10px] md:mx-[15px] lg:mx-[8vw] mt-10">
                  <h1 className="text-xl">Item Details</h1>
                  <p className="text-slate-500">{product.description}</p>
                  <p>From Bangladesh</p>
                </div>

                <div className="flex flex-col bg-white shadow my-10 px-2 py-3 mx-[10px] md:mx-[15px] lg:mx-[8vw] rounded mb-10">
                  <form
                    onSubmit={commentSubmitHandler}
                    className=" border shadow rounded p-2 "
                  >
                    <label
                      htmlFor="review"
                      className=" hover:text-slate-700 text-start hover:underline my-5"
                    >
                      <span>
                        <MdRateReview className="  inline-block" />
                      </span>
                      Create Review
                    </label>
                    <textarea
                      id="review"
                      className="bg-blue-50 border outline-none w-full px-1 py-2 mt-2"
                      type="text"
                      placeholder="write comment..."
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                    />
                    <div>
                      <h3>Give Ratings</h3>
                      <StarRatings
                        rating={createRate}
                        starRatedColor="#FFBF00"
                        changeRating={setCreateRate}
                        numberOfStars={5}
                        name="rating"
                        starDimension="20px"
                        starSpacing="1px"
                      />
                    </div>
                    <div className=" flex items-center">
                      <button className=" uppercase rounded-sm bg-green-500 hover:bg-green-700 text-white  px-3 py-1 my-2">
                        submit
                      </button>
                    </div>
                  </form>

                  <div className="flex mt-5 items-center justify-between">
                    <h1 className="mb-5">Reviews</h1>
                    <button className=" hover:underline">view all</button>
                  </div>

                  {/* comments */}
                  {product?.numOfReviews === 0 ? (
                    <h1 className=" text-center text-lg font-semibold">
                      No Review Yet
                    </h1>
                  ) : (
                    <div className=" flex flex-col ">
                      {product?.reviews?.map((r) => (
                        <ReviewCard
                          name={r.name}
                          rating={r.rating}
                          comment={r.comment}
                          avatar={r.avatar}
                          date={new Date(r.date).toLocaleString()}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ProuductDetails;
